import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-styled-flexboxgrid';
import Box from '../../../../../../components/Box';
import Button from '../../../../../../components/Button';
import ButtonGroup from '../../../../../../components/ButtonGroup';
import Divider from '../../../../../../components/Divider';
import Icon from '../../../../../../components/Icon';
import Input from '../../../../../../components/Input';
import { makeStyles } from '../../../../../../utils/styles';
import { StyledRowSubComponent } from './styled';

const useStyles = makeStyles(css => ({
    dividerTop: css`
        margin-bottom: 30px;
    `,
    dividerBottom: css`
        margin: 15px 0;
    `,
    boxLeft: css`
        margin-right: 40px;
    `,
    boxRight: css`
        margin-left: 40px;
    `,
}))

const RowSubComponent = ({ row, onClickEdit, onClickDelete }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const handleClickEdit = id => () => onClickEdit(id);
    const handleClickDelete = id => () => onClickDelete(id);

    return (
        <StyledRowSubComponent>
            <Divider customStyle={styles.dividerTop} />
            <Row between="xs">
                <Col xs={6}>
                    <Box customStyle={styles.boxLeft}>
                        <Input
                            type="text"
                            label={t("Uprawnienia")}
                            value={row.original?.role_name}
                            readonly
                        />
                        <Input
                            type="text"
                            label={t("Obiekt")}
                            value={row.original?.place_name ?? t("Brak przypisanego obiektu")}
                            readonly
                        />
                    </Box>
                </Col>
                <Col xs={6}>
                    <Box customStyle={styles.boxRight}>
                        <Input
                            type="text"
                            label={t("Adres email")}
                            value={row.original?.user?.email}
                            readonly
                        />
                        <Input
                            type="text"
                            label={t("Dział")}
                            value={row.original?.department_name ?? t("Brak przypisanego działu")}
                            readonly
                        />
                    </Box>
                </Col>
            </Row>
            <Divider customStyle={styles.dividerBottom} />
            <Row end="xs">
                <Col>
                    <ButtonGroup
                        gutters={10}
                    >
                        <Button
                            variant="text"
                            startIcon={
                                <Icon name="edit" width={12} height={12} />
                            }
                            onClick={handleClickEdit(row.original?.id)}
                        >
                            {t("Edytuj użytkownika").toUpperCase()}
                        </Button>
                        <Button
                            variant="text"
                            startIcon={
                                <Icon name="delete" width={12} height={12} />
                            }
                            onClick={handleClickDelete(row.original?.id)}
                        >
                            {t("USUŃ UŻYTKOWNIKA")}
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
        </StyledRowSubComponent>
    );
};

export default RowSubComponent;
